<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="partner-dialog">
    <nb-card-header>
      <h4>
        {{ partner ? ("dialogs.referralPartner.title" | translate: { name: partner.name }) : ("dialogs.referralPartner.titleNew" | translate) }}
      </h4>
    </nb-card-header>

    <nb-card-body>
      @if (conflict) {
        <div class="conflict">
          <p>{{ conflict.message }} {{ "dialogs.referralPartner.conflictQuestion" | translate }}</p>
          <div class="conflict__actions">
            <button type="button" nbButton size="small" status="basic" class="btn-caution" (click)="replaceExisting()" [disabled]="saving">
              {{ "dialogs.referralPartner.conflictReplace" | translate }}
            </button>
            <button type="button" nbButton size="small" status="primary" outline (click)="chooseOtherName()">
              {{ "dialogs.referralPartner.conflictRename" | translate }}
            </button>
          </div>
        </div>
      }
      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.referralPartner.sectionCompany" | translate }}</h5>
        </header>
        <div class="grid">
          <label class="label">{{ "dialogs.referralPartner.name" | translate }}</label>
          <input nbInput fullWidth formControlName="name" />

          <label class="label">{{ "dialogs.referralPartner.legalName" | translate }}</label>
          <div class="field">
            <input nbInput fullWidth formControlName="legal_name" [placeholder]="'dialogs.referralPartner.legalNamePlaceholder' | translate" />
            <p class="hint">{{ "dialogs.referralPartner.legalNameHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.street" | translate }}</label>
          <input nbInput fullWidth formControlName="street" />

          <label class="label">{{ "dialogs.referralPartner.zipCity" | translate }}</label>
          <div class="zip-city">
            <input nbInput formControlName="zip" />
            <input nbInput formControlName="city" />
          </div>

          <label class="label">{{ "dialogs.referralPartner.country" | translate }}</label>
          <input nbInput fullWidth maxlength="2" formControlName="country" />

          <label class="label">{{ "dialogs.referralPartner.taxId" | translate }}</label>
          <div class="field">
            <input nbInput fullWidth formControlName="tax_id" [placeholder]="'dialogs.referralPartner.taxIdPlaceholder' | translate" />
            <p class="hint">{{ "dialogs.referralPartner.taxIdHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.contractReference" | translate }}</label>
          <div class="field">
            <input nbInput fullWidth maxlength="255" formControlName="contract_reference" [placeholder]="'dialogs.referralPartner.contractReferencePlaceholder' | translate" />
            <p class="hint">{{ "dialogs.referralPartner.contractReferenceHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.email" | translate }}</label>
          <div class="field">
            <input nbInput fullWidth type="email" formControlName="email" />
            <p class="hint">{{ "dialogs.referralPartner.emailHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.vatMode" | translate }}</label>
          <nb-select fullWidth formControlName="vat_mode">
            @for (v of vatModes; track v) {
              <nb-option [value]="v">{{ "pages.admin.referrals.vat." + v | translate }}</nb-option>
            }
          </nb-select>
        </div>
      </section>

      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ "dialogs.referralPartner.sectionPayout" | translate }}</h5>
        </header>
        <div class="grid">
          <label class="label" for="referral-billing-via">{{ "dialogs.referralPartner.billingVia" | translate }}</label>
          <div class="field">
            <nb-select id="referral-billing-via" fullWidth formControlName="billing_via">
              <nb-option value="alphalearn">{{ "dialogs.referralPartner.via.alphalearn" | translate }}</nb-option>
              <nb-option value="alphacount">{{ "dialogs.referralPartner.via.alphacount" | translate }}</nb-option>
            </nb-select>
            <p class="hint">{{ "dialogs.referralPartner.viaHint." + form.value.billing_via | translate }}</p>
          </div>

          <label class="label" for="referral-alphacount-from">{{ (viaAlphacount ? "dialogs.referralPartner.alphacountFrom" : "dialogs.referralPartner.alphacountReportFrom") | translate }}</label>
          <div class="field">
            <input id="referral-alphacount-from" nbInput fullWidth type="date" formControlName="alphacount_from" />
            <p class="hint">{{ (viaAlphacount ? "dialogs.referralPartner.alphacountFromHint" : "dialogs.referralPartner.alphacountReportFromHint") | translate }}</p>
          </div>

          <label class="label" for="referral-agreed-on">{{ "dialogs.referralPartner.selfBillingAgreedOn" | translate }}</label>
          <div class="field">
            <input id="referral-agreed-on" nbInput fullWidth type="date" formControlName="self_billing_agreed_on" />
            <p class="hint">{{ "dialogs.referralPartner.selfBillingAgreedOnHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.billingMode" | translate }}</label>
          <div class="field">
            <nb-select fullWidth formControlName="billing_mode">
              @for (b of billingModes; track b) {
                <nb-option [value]="b">{{ "dialogs.referralPartner.billing." + b | translate }}</nb-option>
              }
            </nb-select>
            <p class="hint">{{ "dialogs.referralPartner.billingHint." + form.value.billing_mode | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.payoutMode" | translate }}</label>
          <div class="field">
            <nb-select fullWidth formControlName="payout_mode">
              @for (m of payoutModes; track m) {
                <nb-option [value]="m">{{ "dialogs.referralPartner.payout." + m | translate }}</nb-option>
              }
            </nb-select>
            <p class="hint">{{ "dialogs.referralPartner.payoutHint" | translate }}</p>
          </div>

          <label class="label">{{ "dialogs.referralPartner.payoutDay" | translate }}</label>
          <input nbInput fullWidth type="number" min="1" max="28" formControlName="payout_day" />

          <label class="label">{{ "dialogs.referralPartner.note" | translate }}</label>
          <textarea nbInput fullWidth rows="2" formControlName="note"></textarea>
        </div>
      </section>
    </nb-card-body>

    <nb-card-footer>
      <button type="button" nbButton status="danger" outline (click)="dialogRef.close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary" [disabled]="saving">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
